<template>
  <div v-loading="!page" class="mode-step">
    <template v-if="page">
      <div class="entry-info">
        <i class="el-icon-box entry-info__icon"></i>
        Хранится на текущий момент в данном структурном подразделении:
        <b>{{ page.amount }} {{ unitName }}</b>
        <template v-if="hasStorage">
          (из них направлено на хранение:
          <b>{{ round(page.sumAmountGet) }} {{ unitName }}</b>)
        </template>
      </div>
      <div
        v-if="transportUnit"
        class="entry-warning"
        :class="'is-' + transportUnit.status"
      >
        <i class="el-icon-warning entry-warning__icon"></i>
        <template v-if="transportUnit.status === 'over'">
          Превышено количество данного вида отхода для временного хранения (одна
          транспортная единица) на:
          <b>{{ transportUnit.amount }} {{ unitName }}</b>
        </template>
        <template v-else-if="transportUnit.status === 'reached'">
          Достигнуто максимально допустимое количество данного отхода для
          временного хранения (одна транспортная единица)
        </template>
        <template v-else>
          Внимание! До накопления одной транспортной единицы осталось:
          <b>{{ transportUnit.amount }} {{ unitName }}</b>
        </template>
      </div>
      <choice-cards
        :value="mode"
        :groups="modeGroups"
        @input="pickMode"
      ></choice-cards>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ChoiceCards from "@/components/ecologist/dataEntryNew/choiceCards";
import StepMixin from "./stepMixin";
import { INCOMING, MODES, OUTGOING, isAvailable, round } from "./entryModes";

// Этап выбора режима: поступление или расход
export default {
  name: "modeStep",
  components: { ChoiceCards },
  mixins: [StepMixin],

  computed: {
    ...mapGetters("wasteEntry", ["hasStorage", "noRemainder", "transportUnit"]),
    // Расход: движения внутри предприятия в строку, вывоз контрагенту - отдельно под ними
    modeGroups() {
      const card = (type) => ({
        type,
        title: MODES[type].title,
        icon: MODES[type].icon,
      });
      const outgoing = (types) =>
        types
          .filter((type) => isAvailable(type, this.page))
          .map((type) => ({
            ...card(type),
            disabled: this.noRemainder,
            reason: "Нет остатка отхода для списания",
          }));
      return [
        { title: "Поступление", items: INCOMING.map(card) },
        {
          title: "Расход",
          items: outgoing(OUTGOING.filter((type) => type !== "contractor")),
        },
        { items: outgoing(["contractor"]) },
      ];
    },
  },

  methods: {
    round,

    async pickMode(mode) {
      if (await this.changeMode(mode)) this.step = "entry";
    },

    // Смена режима стирает всё введённое: поля и проверки у режимов разные.
    // Возвращает false, если пользователь отказался
    async changeMode(mode) {
      if (mode === this.mode) return true;
      if (this.hasEntered) {
        try {
          await this.confirm(
            "Внимание",
            "Выбранные даты и введённые количества будут потеряны. Сменить режим?",
            "warning",
            "Да",
            "Нет"
          );
        } catch {
          return false;
        }
      }
      this.$store
        .dispatch("wasteEntry/changeMode", mode)
        .catch(() => this.$message.error("Не удалось загрузить справочники"));
      return true;
    },
  },
};
</script>

<style scoped>
.mode-step {
  min-height: 200px;
}
/*
  Остаток - блок в рамке, как календарь и таблица (цвет и толщина рамки те же), без жирного:
  заметен размером и зелёными значениями
*/
.entry-info {
  margin-bottom: 20px;
  padding: 10px 16px;
  border: 1.5px solid #dcdfe6;
  border-radius: 8px;
  font-size: 16px;
  color: #606266;
}
.entry-info__icon {
  margin-right: 6px;
  vertical-align: -3px;
  font-size: 20px;
  color: #409eff;
}
.entry-info b {
  font-size: 18px;
  font-weight: normal;
  color: #67c23a;
}
/* Транспортная единица: превышена или достигнута - красным, почти набрана - жёлтым */
.entry-warning {
  margin: -8px 0 20px;
  padding: 10px 16px;
  border: 1.5px solid;
  border-radius: 8px;
  font-size: 15px;
}
.entry-warning.is-over,
.entry-warning.is-reached {
  border-color: #fbc4c4;
  background: #fef0f0;
  color: #f56c6c;
}
.entry-warning.is-near {
  border-color: #f5dab1;
  background: #fdf6ec;
  color: #e6a23c;
}
.entry-warning__icon {
  margin-right: 6px;
  font-size: 18px;
  vertical-align: -2px;
}
</style>
